/** @jsxImportSource @emotion/react */
import { useSelector } from "react-redux";

import { DeviceList } from "../../Devices/DeviceList";
import FullPageLayout from "../Layout/FullPageLayout";
import { FormContainer } from "../../Helper/FormContainer";


function Settings() {
    const user = useSelector((state) => state.auth.user);

    return (
        <FullPageLayout>
            <FormContainer
                title={`Hi ${user.first_name}!`}
                subtitle={<span>You are logged in as <b>{user.username}</b> | <b>{user.email}</b></span>}
            >
                <div>
                    <h3>Select Device</h3>

                    <DeviceList />
                </div>
            </FormContainer>
        </FullPageLayout>
    );
}

export default Settings;
